module.exports = __webpack_public_path__ + "static/RTC360-8cfaeeaf94fc285afa0af318cf686992.webp";